import styled from 'styled-components';
import { BottomSheet } from 'react-spring-bottom-sheet';

export const StyledSheetContainer = styled.div`
  padding: ${({ theme }): number => theme.sizes[9]}px;
`;

export const StyledBottomSheet = styled(BottomSheet)`
  [data-rsbs-overlay],
  [data-rsbs-backdrop],
  [data-rsbs-root]:after {
    z-index: ${({ theme }): number => theme.zIndices[8]};
    border-radius: ${({ theme }): string =>
      `${theme.sizes[8]}px ${theme.sizes[8]}px 0 0`};
    margin: auto;
  }

  [data-rsbs-overlay] {
    max-width: 440px;
  }
`;
